<template>
  <div class="pictures">
    <h2 class="c999 mt20 mb20">外检照片</h2>
    <!-- <van-uploader v-model="fileList" multiple>
    </van-uploader> -->
    <van-uploader v-model="fileList" :before-read="beforeRead" :before-delete="deletePhoto" :accept="'image/*'"
      multiple />
    <!-- 按钮 -->
    <div class="successbtn btncolor photoenter" @click="uploadPhoto">确定</div>
    <div class="cancelbtn mt20">取消</div>
        <!-- 按钮end -->
    <div class="deleteTip pubsontext" v-show="tipshow">
      <div class="tipSon">
        <p>确定要退出当前页？</p>
        <div class="footerBut">
          <span class="cancle" @click="tipColse">取消</span>
          <span class="sure" @click="tipBacks">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Toast
  } from 'vant'
  export default {
    name: 'pictures',
    data() {
      return {
        tipshow: false, //控制提示弹窗显隐
        backStatu: false, //判断当执行页面回退时是否要执行next(true);
        fileList: [],
        photoData: [],
        orderId: '',
        type: '',
        uploadFlag: true
      }
    },
    mounted() {
      this.orderId = this.$route.query.orderId
      this.type = this.$route.query.type
    },

    methods: {
      // 上传前压缩图片
      async beforeRead(file) {
        if (file.length) { // file.length为真的时候说明是多图上传   要循环多图将file对象放进form中
          for (let i = 0; i < file.length; i++) {
            var f = await this.$api.compressImg(file[i]) // await只能放在async函数里 await会等待异步方法的返回值拿到以后在执行后面的方法
            this.photoData.push(f)
          }
        } else {
          let f = await this.$api.compressImg(file)
          this.photoData.push(f)
        }
      },
      deletePhoto(file, detail) {
        var index = detail.index
        this.photoData.splice(index, 1)
        return true
      },
      // 提交图片
      uploadPhoto() {
        var that = this
        if (!that.uploadFlag) {
          return
        }
        if (this.photoData.length <= 0) {
          Toast('请添加图片')
          return
        }
        that.uploadFlag = false
        var formData = new FormData() // 创建新的form
        for (let i = 0; i < this.photoData.length; i++) {
          var f = this.photoData[i]
          formData.append('imageUrls', f)
        };
        // var data = {'photo-data':formData,orderId:this.orderId}
        formData.append('orderId', this.orderId)
        var data = formData
        var photourl = ''
        if (this.type == 0) {
          photourl = '/we-chat/gzh/upload-qc-photos'
        }
        if (this.type == 1) {
          photourl = '/we-chat/gzh/upload-hc-photos'
        }
        Toast.loading({
          message: '上传中...',
          forbidClick: true,
          duration: 0
        })
        this.$api.PHrequest(photourl, 'POST', data).then((res) => {
          if (res.code == 200) {
            Toast('上传成功')
            setTimeout(function() {
              that.$router.replace({
                path: '/service'
              })
            }, 500)
            that.uploadFlag = true
          } else {
            Toast('上传失败')
            that.uploadFlag = true
          }
        })
      },
      tipColse() { //控制提示弹窗显隐
        this.tipshow = !this.tipshow;
      },
      tipBacks() {
        this.backStatu = true;
        this.$router.go(-1);
      },

    }
  }
</script>

<style>
  .pictures {
    width: 100%;
    background: #fff;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 0.32rem;
    padding-bottom: 0.6rem;
  }

  .photolist {
    background: #fff;
    width: 100%;
    min-height: 3.88rem;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0.24rem;
  }

  .photoli {
    width: 1.6rem;
    height: 1.6rem;
    margin-right: 0.2rem;
    position: relative;
    margin-bottom: 0.2rem;
  }

  .photoli:nth-child(4n) {
    margin-right: 0;
  }

  .photoli img {
    width: 100%;
    height: 100%;
  }

  .deletebtn {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0;
    right: 0;
  }

  .photoenter {
    margin-top: 1.48rem;
  }

  .uploadinput {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }

  .van-uploader__preview {
    margin: 0 0.09rem 0.09rem 0;
  }

  .van-uploader__preview-image {
    width: 1.6rem;
    height: 1.6rem;
  }

  .van-uploader__wrapper>div:nth-child(4n) {
    margin-right: 0;
  }

  .van-uploader__upload {
    width: 1.6rem;
    height: 1.6rem;
  }
  .deleteTip {
      height: 100%;
      width: 100%;
      position: fixed;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      z-index: 4;
  }
  .tipSon{
    width: 6rem;
  }
  .pubsontext .tipSon {
      top: 30%;
  }
  .deleteTip .tipSon {
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: auto 0;
      background: #fff;
      border-radius: 0.2rem;
      padding: 1rem 0.4rem 0.5rem;
  }
  .pubsontext .tipSon p {
      text-align: center;
      font-size: 0.3rem;
  }
  .deleteTip .tipSon p {
      color: #000000;
      line-height: 0.42rem;
      padding-bottom: 0.5rem;
  }
  .deleteTip .tipSon .footerBut {
      display: flex;
      line-height: 0.7rem;
      font-size: 0.36rem;
      color: #666;
  }
  .deleteTip .tipSon .footerBut .cancle {
      background: #4293e5;
      color: #fff;
      margin-right: 0.1rem;
  }
  .deleteTip .tipSon .footerBut .sure {
      color: #4293e5;
      margin-left: 0.1rem;
  }
  .deleteTip .tipSon .footerBut .cancle, .deleteTip .tipSon .footerBut .sure {
      flex: 1;
      font-size: 0.36rem;
      border: 0.01rem solid #4293e5;
      border-radius: 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/view/pictures.vue